<template>
  <div class="store">
    <v-col class="pt-5">
      <div class="pt-3">
        <v-card elevation="3" class="rounded-lg">
          <!-- <div class="d-none d-md-block">
            <v-img width="100%" class="rounded-lg" src="/assets/background/header-store.svg"></v-img>
          </div> -->
          <div class="position-absolute store-info pa-3 rounded-lg mt-n5 bg-white">
            <v-row>
              <v-col md="5" class="py-0">
                <v-row>
                  <v-col cols="3" class="py-0 pr-0 my-auto">
                    <v-avatar class="store-picture">
                      <img
                        :src="detailStore.store_image ? detailStore.store_image : '/assets/seller/default-toko.svg'"
                      />
                    </v-avatar>
                  </v-col>
                  <v-col cols="9" class="py-0 my-auto">
                    <div
                      class="text-uppercase black--text font-weight-bold text-subtitle-2"
                      v-if="detailStore.store_is_b2b == 'false'"
                    >{{detailStore.store_name}}</div>
                    <v-badge color="orange darken-1" content="Store Partner" inline v-else>
                      <div
                        class="text-uppercase black--text font-weight-bold text-subtitle-2"
                      >{{detailStore.store_name}}</div>
                    </v-badge>
                    <div class="d-flex justify-space-between">
                      <div class="pt-1 text-caption text-body-sm-2 d-flex">
                        <v-icon small>mdi-map-marker</v-icon>
                        <div
                          class="pl-1"
                        >{{detailStore.store_city_name}}, {{detailStore.store_province_name}}</div>
                      </div>
                      <div
                        class="text-body-2 pt-2 pl-4 cursor-pointer text-right"
                        v-if="userData"
                        @click="copyme"
                      >
                        <span v-if="userData.user_network_id > 0">
                          <v-icon color="primary">mdi-share-variant</v-icon>
                          <span class="pl-1">Bagikan</span>
                          <input type="hidden" :value="getUrlReferal()" id="inputCopy" />
                        </span>
                      </div>
                    </div>
                    <div class="d-flex pt-2">
                      <v-btn
                        outlined
                        large
                        color="primary"
                        class="px-2 px-md-3 rounded-lg mr-2"
                        v-if="false"
                      >
                        <v-icon>mdi-chat-processing-outline</v-icon>
                        <div
                          class="pl-sm-1 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block"
                        >Kirim Pesan</div>
                      </v-btn>
                      <v-btn outlined large color="grey darken-1" class="rounded-lg" v-if="false">
                        <v-icon>mdi-storefront-outline</v-icon>
                        <div
                          class="pl-sm-1 text-caption text-body-sm-2 text-capitalize font-weight-bold d-none d-md-block"
                        >Info Toko</div>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="7" class="py-0 left-border my-auto text-body-2 d-none d-md-block">
                <v-row class="pl-5">
                  <v-col cols="5">
                    <v-row class>
                      <v-col class="py-0 pr-0">Penilaian</v-col>
                      <v-col class="py-0 pr-0 black--text font-weight-bold">Belum ada</v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 pr-0">Produk</v-col>
                      <v-col
                        class="py-0 pr-0 black--text font-weight-bold"
                      >{{ detailStore.store_product_count}}</v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="7">
                    <v-row>
                      <v-col cols="5" class="pa-0">Total Transaksi</v-col>
                      <v-col
                        cols="7"
                        class="pa-0 black--text font-weight-bold"
                      >{{ detailStore.store_trx_count}}</v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col cols="5" class="pa-0">Bergabung</v-col>
                      <v-col
                        cols="7"
                        class="pa-0 black--text font-weight-bold"
                      >{{ detailStore.store_input_datetime | tanggal}}</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
      <div class="pt-8-rem">
        <v-tabs color="black" class="no-slider">
          <v-tab
            class="text-subtitle-1 text-capitalize font-weight-bold"
            @click="showTab('product')"
          >Produk</v-tab>
          <v-tab
            v-if="false"
            class="text-subtitle-1 text-capitalize font-weight-bold"
            @click="showTab('review')"
          >Ulasan</v-tab>
        </v-tabs>
      </div>
      <div class="pt-5" v-if="tabShow == 'product'">
        <v-row>
          <v-col md="2" class="pr-0 d-none d-md-block">
            <div class="rounded-lg pa-3 cus-box-shadow">
              <div class="text-caption text-uppercase font-weight-bold">Etalase Toko</div>
              <v-btn
                text
                small
                :color="etalase == 'all' ? 'primary' : 'grey darken-4'"
                class="px-0 text-capitalize font-weight-bold"
                @click="changeEtalase('all')"
              >Semua Produk</v-btn>
              <v-btn
                text
                small
                :color="etalase == 'sold' ? 'primary' : 'grey darken-4'"
                class="px-0 text-capitalize font-weight-bold"
                @click="changeEtalase('sold')"
              >Produk Terjual</v-btn>
              <!-- <v-btn text small color="grey darken-4" class="px-0 text-capitalize font-weight-bold">
								Aksesori Mobile
							</v-btn>
							<v-btn text small color="grey darken-4" class="px-0 text-capitalize font-weight-bold">
								ROG Series
              </v-btn>-->
            </div>
          </v-col>
          <v-col cols="12" md="10" class="pl-md-5">
            <div>
              <v-row class="px-3 pb-3 d-flex d-md-none">
                <v-col cols="3" class="pa-0 my-auto">
                  <div class="pt-1 pr-2">
                    <div class="font-weight-bold text-body-2">Kategori :</div>
                  </div>
                </v-col>
                <v-col cols="9" class="pa-0">
                  <div class="pt-1">
                    <v-autocomplete
                      outlined
                      dense
                      hide-details
                      placeholder="Pilih Kategori"
                      class="rounded-lg text-body-2"
                      no-data-text="Belum ada data tersedia"
                    ></v-autocomplete>
                  </div>
                </v-col>
              </v-row>
              <v-list class="py-0">
                <v-list-item dense class="px-0">
                  <v-col md="4" class="pa-0 d-none d-md-block">
                    <v-text-field
                      v-model="productNameFilter.value"
                      hide-details
                      placeholder="Cari Produk Ditoko ini"
                      append-icon="mdi-magnify"
                      outlined
                      dense
                      class="rounded-lg text-body-2"
                      @click:append="cari"
                      @keyup.enter="cari"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="3" md="1" class="pa-0">
                    <div class="pt-1 pr-2">
                      <div class="font-weight-bold text-body-2">Urutkan :</div>
                    </div>
                  </v-col>
                  <v-col cols="9" md="3" class="pa-0">
                    <div class="pt-1">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details
                        placeholder="Urutkan dari"
                        class="rounded-lg text-body-2"
                        no-data-text="Belum ada data tersedia"
                        @input="cari"
                        v-model="sort"
                        :items="listSort"
                        item-text="sortLabel"
                        return-object
                      ></v-autocomplete>
                    </div>
                  </v-col>
                </v-list-item>
              </v-list>
            </div>
            <div class="pt-5">
              <div v-if="productbyStore.length == 0 && !productbyStorePagination">
                <v-row class="ml-md-0">
                  <v-col class="py-0">
                    <v-row class="justify-center">
                      <v-col cols="7" md="4">
                        <v-img width="100%" src="/assets/icons/transaksi-kosong.svg"></v-img>
                      </v-col>
                    </v-row>
                    <div class="text-center pb-3">
                      <div class="pt-1 text-body-1 font-weight-bold">Belum ada produk di toko ini.</div>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else-if="productbyStore.length == 0 && productbyStorePagination">
                <v-row class="ml-md-0">
                  <v-col class="py-0">
                    <v-row class="justify-center">
                      <v-col cols="7" md="4">
                        <v-img width="100%" src="/assets/icons/ilus-search.svg"></v-img>
                      </v-col>
                    </v-row>
                    <div class="text-center pb-3">
                      <div
                        class="pt-1 text-body-2 text-md-body-1 font-weight-bold"
                      >Oops.. produk yang Anda cari tidak tersedia</div>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row class="ml-0">
                  <v-col
                    class="pl-0 pt-0 col-md-25"
                    cols="6"
                    sm="4"
                    v-for="(item, i) in productbyStore"
                    :key="i"
                  >
                    <v-hover v-slot:default="{ hover }">
                      <router-link
                        :to="{ name: 'product-detail',params: { id: item.product_id, slug: item.product_slug_name } }"
                        class="text-deco"
                      >
                        <v-card outlined class="rounded-lg" :elevation="hover ? 4 : 0">
                          <div class="pa-3">
                            <v-img
                              class="rounded-lg"
                              :src="item.product_image[0] ? item.product_image[0] : '/assets/product/default.png'"
                              height="150"
                            ></v-img>
                          </div>
                          <v-col class="grey--text text--darken-2 px-2">
                            <div class="text-body-2 product-name">{{ item.product_name}}</div>
                            <div class="product-price mt-2">
                              <div
                                class="text-decoration-line-through font-size-12 pink--text"
                                v-if="item.product_price != item.product_price_origin"
                              >Rp {{item.product_price_origin | toNumber}}</div>
                              <div
                                class="text-subtitle-1 font-weight-bold"
                              >Rp {{item.product_price | toNumber}}</div>
                            </div>
                            <div class="text-caption">
                              <span
                                v-if="item.product_enable_discount=='1'"
                                class="red white--text"
                              >{{ item.product_discount_percent | toNumber }}%</span>
                              &nbsp;
                              <strike
                                v-if="item.product_enable_discount=='1'"
                              >Rp {{ item.product_gross | toNumber }}</strike>
                            </div>
                            <star-rating v-if="false" :rating="item.product_rating"></star-rating>

                            <div class="text-caption">
                              <span>{{ item.product_sold_count | toNumber }} terjual</span>
                            </div>
                          </v-col>
                        </v-card>
                      </router-link>
                    </v-hover>
                  </v-col>
                </v-row>
                <v-row class="pt-4 justify-center">
                  <v-pagination
                    v-if="productbyStorePagination.total_data > 0"
                    v-model="page"
                    @input="changePage"
                    :length="productbyStorePagination.total_page"
                    class="elevation-0"
                  ></v-pagination>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="pt-5" v-if="tabShow == 'review'">
        <div class="text-body-2 pt-3">
          <v-row class="px-3" v-for="i in 2" :key="i">
            <v-col cols="12" md="2" class="pt-5 border d-flex justify-start d-md-block">
              <v-img class="ma-md-auto store-picture" src="/assets/product/swiss-clock.png"></v-img>
              <div
                class="my-auto pt-md-3 pl-2 pl-md-0 text-center text-body-2 font-weight-bold"
              >Swiss Army Clock</div>
            </v-col>
            <v-col
              cols="12"
              md="10"
              class="py-0 top-md-border bottom-border left-xs-border right-xs-border"
            >
              <v-row v-for="i in 2" :key="i">
                <v-col cols="1" class="d-none d-md-block">
                  <v-img class="rounded-circle" width="80" src="/assets/product/swiss-clock.png"></v-img>
                </v-col>
                <v-col cols="12" md="11" class="pl-2">
                  <div class="font-weight-bold">08000001018</div>
                  <div class="pt-1">
                    <v-icon small color="yellow darken-1" v-for="i in 5" :key="i">mdi-star</v-icon>
                  </div>
                  <div class="pt-5">Bla bla bla bla bla</div>
                  <div class="pt-5">
                    <v-row class="mx-0">
                      <div class="pr-4 pb-2" v-for="i in 3" :key="i">
                        <v-img
                          class="rounded-lg store-picture"
                          src="/assets/product/swiss-clock.png"
                        ></v-img>
                      </div>
                    </v-row>
                  </div>
                  <div class="pt-3 grey--text">2020-09-04 17:59</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="pt-4 justify-center">
            <v-pagination v-model="page" :length="3" class="elevation-0"></v-pagination>
          </v-row>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import StarRating from "@/components/StarRating";
import authHelper from "@/helpers/auth";

export default {
  components: {
    StarRating
  },
  data() {
    return {
      tabShow: "product",
      etalase: "all",
      page: 1,
      params: [],
      productNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "product_name"
      },
      sort: "",
      sortBy: "product_sold_count",
      sortDir: "DESC",
      listSort: [
        {
          sortBy: "product_price",
          sortDir: "ASC",
          sortLabel: "Harga Terendah"
        },
        {
          sortBy: "product_price",
          sortDir: "DESC",
          sortLabel: "Harga Tertinggi"
        },
        {
          sortBy: "product_input_datetime",
          sortDir: "DESC",
          sortLabel: "Produk Terbaru"
        },
        {
          sortBy: "product_sold_count",
          sortDir: "DESC",
          sortLabel: "Produk Terlaris"
        },
        {
          sortBy: "product_view_count",
          sortDir: "DESC",
          sortLabel: "Produk Terpopuler"
        }
      ]
    };
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("store", ["detailStore"]),
    ...mapState("productExternal", [
      "productbyStore",
      "productbyStorePagination"
    ])
  },
  methods: {
    ...mapActions("store", ["getStoreDetail"]),
    ...mapActions("productExternal", ["getProductByStore"]),
    ...mapMutations("store", ["clearDataStore"]),
    ...mapMutations("productExternal", ["clearProductExternal"]),

    showTab(tab) {
      this.tabShow = tab;
      this.page = 1;
    },
    changeEtalase(etalase) {
      this.etalase = etalase;
      this.cari();
    },
    changePage() {
      if (this.tabShow == "product") {
        let params = this.queryString({
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir
        });
        params["id"] = this.detailStore.store_id;
        params["sold"] = this.etalase == "sold" ? true : "";
        this.getProductByStore(params);
      }
    },
    cari() {
      this.params = [];

      if (this.productNameFilter.value)
        this.params.push(this.productNameFilter);

      this.sortBy = this.sort.sortBy;
      this.sortDir = this.sort.sortDir;
      this.page = 1;
      let params = this.queryString({
        page: this.page,
        params: this.params,
        sort: this.sortBy,
        dir: this.sortDir
      });
      params["id"] = this.detailStore.store_id;
      params["sold"] = this.etalase == "sold" ? true : "";
      this.getProductByStore(params);
    },
    getUrlReferal() {
      return window.location + "/" + this.userData.user_mobilephone;
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(() => {
          this.$store.commit("makeAlert", {
            code: "success",
            type: "success",
            message: "Tautan berhasil disalin",
            show: true
          });
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },
  created() {
    this.getStoreDetail({
      slug: this.$route.params.slug
    })
      .then(() => {
        this.$store.dispatch(
          "setPageTitle",
          this.detailStore.store_name.toUpperCase()
        );
        this.getProductByStore({
          id: this.detailStore.store_id
        });
      })
      .catch(() => {
        setTimeout(() => {
          this.$router.push("/");
        }, 3000);
      });
    let referral = this.$route.params.referral;
    if (referral) {
      let splitUrl = this.$route.path.split("/");
      splitUrl.pop();
      authHelper.setReferal(referral);
      this.$router.push(splitUrl.join("/"));
    }
  },
  beforeDestroy() {
    this.clearProductExternal();
  }
};
</script>
